export default __webpack_public_path__ + "static/655-3114a8ceecb06b98029fafcd1e13e367.gif";